import Link from 'next/link';
import Image from 'next/image';
import { ArrowRight } from 'react-feather';
import i18n from 'i18next';

// createdAt "2025/10/10 12:57" → "2025 оны 10-р сарын 10" / "October 10, 2025"
export const formatDate = (value, isEn) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return isEn
        ? d.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
          })
        : `${d.getFullYear()} оны ${d.getMonth() + 1}-р сарын ${d.getDate()}`;
};

// Мэдээний карт (мэдээний жагсаалт, нүүр): том зураг, огноо, serif гарчиг,
// товч тайлбар, "Дэлгэрэнгүй →". Бүх текст баазын news бичлэгээс.
const NewsCard = ({ item, isEn, sizes = '(max-width: 768px) 100vw, 50vw' }) => {
    const title = isEn ? item.nameEng : item.name;
    const excerpt = isEn ? item.descriptionEng : item.description;
    return (
        <Link href={`/news/${item.id}`} className="group block">
            <div className="relative aspect-[16/9] rounded-xl overflow-hidden bg-sand">
                {item.imageUrl ? (
                    <Image
                        src={item.imageUrl}
                        alt={title}
                        fill
                        sizes={sizes}
                        className="object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                    />
                ) : null}
            </div>
            <p className="mt-4 text-[11px] uppercase tracking-[0.2em] text-stone">
                {formatDate(item.createdAt, isEn)}
            </p>
            <p className="mt-2 font-serif text-[24px] leading-snug text-ink line-clamp-2 group-hover:text-cocoa transition-colors">
                {title}
            </p>
            {excerpt ? (
                <p className="mt-2 text-[13px] text-ink/65 leading-relaxed line-clamp-2">
                    {excerpt}
                </p>
            ) : null}
            <p className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-ink">
                {i18n.t('title.more')}
                <ArrowRight
                    size={12}
                    className="transition-transform duration-200 group-hover:translate-x-0.5"
                />
            </p>
        </Link>
    );
};

export default NewsCard;
